import { render } from "./ComparisonSlider.vue?vue&type=template&id=3172f582&scoped=true&ts=true"
import script from "./ComparisonSlider.vue?vue&type=script&lang=ts"
export * from "./ComparisonSlider.vue?vue&type=script&lang=ts"

import "./ComparisonSlider.vue?vue&type=style&index=0&id=3172f582&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3172f582"]])

export default __exports__